import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Play, SignIn, SignOut } from '@phosphor-icons/react';

function Home() {
  const { currentUser, logout } = useAuth();

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden bg-gradient-to-br from-green-100 via-pink-50 to-green-50">
      <main className="relative flex-grow flex items-center justify-center px-4 py-12">
        <Card className="w-full max-w-[420px] border-0 bg-white/0 shadow-none group">
          <CardHeader className="text-center pb-6 pt-8">
            {/* Logo Image */}
            <div className="mx-auto -mb-6 relative">
              <div className="w-48 h-48 mx-auto transition-all duration-500 ease-out group-hover:scale-105 group-hover:rotate-2 drop-shadow-xl">
                <img
                  src="/vava_small.png"
                  alt="VIVA FLIPA Logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>

            <CardTitle className="text-4xl font-bold text-gray-900 mb-3 tracking-tight">
              *VIVA FLIP
            </CardTitle>
            <CardDescription className="text-base text-gray-600">
              재미있게 배우고 기억하세요!
            </CardDescription>
          </CardHeader>

          <CardContent className="space-y-3 pb-8 px-8 flex flex-col items-center">
            {currentUser ? (
              <>
                <Link to="/teacher-dashboard" className="group/button">
                  <Button className="w-[250px] h-12 text-base font-semibold shadow-lg shadow-primary/20 hover:shadow-primary/30 transition-all" size="lg">
                    <Play size={18} weight="fill" className="mr-2" />
                    시작하기
                  </Button>
                </Link>
                <Button
                  onClick={logout}
                  variant="outline"
                  className="w-[250px] h-12 text-base font-medium border-2 hover:bg-gray-50"
                >
                  <SignOut size={18} weight="duotone" className="mr-2" />
                  로그아웃
                </Button>
              </>
            ) : (
              <Link to="/login">
                <Button className="w-[250px] h-12 text-base font-semibold shadow-lg shadow-primary/20 hover:shadow-primary/30 transition-all" size="lg">
                  <SignIn size={18} weight="fill" className="mr-2" />
                  로그인하기
                </Button>
              </Link>
            )}
          </CardContent>
        </Card>
      </main>
    </div>
  );
}

export default Home;